import LegalLayout, { LP, LL, LMail } from "@/components/LegalLayout";

const SECTIONS = [
  {
    heading: "1. Scope",
    body: (
      <>
        <LP>
          These Terms of Sale (Conditions Générales de Vente) govern all services provided by{" "}
          <strong className="text-white">4EMPIRE</strong> — digital marketing, brand strategy and
          identity, social media management, paid advertising, content creation, growth strategy,
          and website & landing page services.
        </LP>
        <LP>
          Any order placed with 4EMPIRE implies the client's full acceptance of these terms. Company
          details (legal entity, registration number, registered address): to be completed.
        </LP>
      </>
    ),
  },
  {
    heading: "2. Quotes & orders",
    body: (
      <>
        <LP>
          Every service is subject to a written quote describing the scope, deliverables, schedule
          and price. Unless stated otherwise, a quote is valid for 30 days from its issue date.
        </LP>
        <LP>
          An order is confirmed upon written acceptance of the quote (including by email) and, where
          applicable, payment of the deposit stated in the quote.
        </LP>
      </>
    ),
  },
  {
    heading: "3. Prices & payment",
    body: (
      <>
        <LL
          items={[
            "Prices are those stated in the accepted quote, in euros, with taxes applied as indicated on the invoice.",
            "The payment schedule (deposit, milestones, balance) is defined in each quote.",
            "In case of late payment, statutory late-payment interest applies and 4EMPIRE may suspend ongoing work until settlement.",
          ]}
        />
      </>
    ),
  },
  {
    heading: "4. Client obligations",
    body: (
      <LP>
        The client agrees to provide, in a timely manner, the information, materials, access and
        approvals reasonably required to perform the services. Delays caused by missing client input
        extend delivery deadlines accordingly.
      </LP>
    ),
  },
  {
    heading: "5. Delivery & acceptance",
    body: (
      <LP>
        Deliverables are provided as defined in the quote, including the revision rounds it
        specifies. Unless the client sends written remarks within 14 days of delivery, deliverables
        are deemed accepted.
      </LP>
    ),
  },
  {
    heading: "6. Intellectual property",
    body: (
      <>
        <LP>
          Rights to the final deliverables are transferred to the client upon full payment. Working
          files, methods, tools and know-how remain the property of 4EMPIRE.
        </LP>
        <LP>
          Unless the client objects in writing, 4EMPIRE may present the work produced as a
          professional reference (portfolio, case study).
        </LP>
      </>
    ),
  },
  {
    heading: "7. Confidentiality",
    body: (
      <LP>
        Each party agrees to keep confidential all non-public information received from the other
        party in the course of the engagement, for its duration and beyond.
      </LP>
    ),
  },
  {
    heading: "8. Liability",
    body: (
      <LP>
        Marketing and growth services are performed under an obligation of means: 4EMPIRE commits
        its expertise and diligence but does not guarantee specific commercial outcomes. In any
        case, 4EMPIRE's liability is limited to the amounts actually paid for the service concerned.
      </LP>
    ),
  },
  {
    heading: "9. Cancellation",
    body: (
      <LP>
        The client may cancel an engagement in writing at any time. Work already performed and costs
        already incurred remain due. Deposits and refunds are handled according to our Refund
        Policy.
      </LP>
    ),
  },
  {
    heading: "10. Governing law & disputes",
    body: (
      <LP>
        These terms are governed by the law applicable at 4EMPIRE's registered office (jurisdiction
        to be completed). The parties will first seek an amicable resolution; failing that, the
        competent courts of that jurisdiction will apply.
      </LP>
    ),
  },
  {
    heading: "11. Contact",
    body: (
      <LP>
        For any question about these terms, contact us at <LMail /> or on WhatsApp at
        +351 926 856 052.
      </LP>
    ),
  },
];

export default function TermsOfSale() {
  return (
    <LegalLayout
      testid="terms-of-sale"
      title="Terms of"
      accent="Sale."
      description="Last updated: October 2026. The general terms and conditions (CGV) governing services provided by 4EMPIRE."
      sections={SECTIONS}
    />
  );
}
